export const DEFAULT_SIZE = 56;
export const DEFAULT_VARIANT = 'primary';
